import React from 'react';
import SEO from '../components/SEO';

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 40px',
    fontFamily: '"Times New Roman", Times, serif',
    lineHeight: '1.6',
    color: '#333',
    backgroundColor: '#fff',
    paddingTop: '40px',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '400',
    margin: '0 0 20px 0',
    letterSpacing: '1px',
    color: '#333',
    fontFamily: '"Times New Roman", Times, serif',
    textAlign: 'left',
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: '400',
    margin: '40px 0 15px 0',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  text: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '20px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  jobCard: {
    border: '1px solid #ccc',
    padding: '25px',
    marginBottom: '25px',
    backgroundColor: '#fff',
  },
  jobTitle: {
    fontSize: '18px',
    fontWeight: '400',
    color: '#333',
    marginBottom: '10px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  jobMeta: {
    fontSize: '14px',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '15px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  jobDescription: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '15px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  requirementsList: {
    listStyle: 'disc',
    paddingLeft: '20px',
    marginBottom: '15px',
  },
  requirementItem: {
    fontSize: '15px',
    color: '#333',
    lineHeight: '1.5',
    marginBottom: '8px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  link: {
    color: '#666',
    textDecoration: 'underline',
    fontFamily: '"Times New Roman", Times, serif',
  }
};

function Careers() {
  return (
    <div style={styles.container}>
      <SEO
        title="Career Opportunities - Join Sapienta VC"
        description="Explore career opportunities at Sapienta Venture Capital. Join our team of investment professionals focused on AI, fintech, and technology innovation."
        keywords="venture capital careers, VC jobs, investment careers, sapienta vc jobs, fintech careers"
        url="https://sapienta.vc/careers"
      />

      <p style={styles.text}>
        Join Sapienta Venture Capital and help shape the future of technology investing. We're looking
        for exceptional individuals who share our passion for backing ambitious projects and supporting
        transformative companies in payment innovation, AI, and cutting-edge technology.
      </p>

      <p style={styles.text}>
        At Sapienta, you'll work alongside experienced investment professionals, gain exposure to
        cutting-edge technologies, and have the opportunity to make a meaningful impact on the
        next generation of successful companies.
      </p>

      <h2 style={styles.subHeading}>Current Openings</h2>

      <div style={styles.jobCard}>
        <h3 style={styles.jobTitle}>Senior Investment Associate</h3>
        <div style={styles.jobMeta}>Full-Time • Abu Dhabi, UAE</div>
        <p style={styles.jobDescription}>
          We're seeking a Senior Investment Associate to join our investment team and help identify,
          evaluate, and support portfolio companies in our focus areas of AI, fintech, and payment innovation.
        </p>
        <p style={styles.jobDescription}>
          <strong>Key Responsibilities:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>Lead due diligence processes for potential investments</li>
          <li style={styles.requirementItem}>Develop financial models and investment memoranda</li>
          <li style={styles.requirementItem}>Support portfolio companies with strategic initiatives</li>
          <li style={styles.requirementItem}>Represent Sapienta at industry events and conferences</li>
          <li style={styles.requirementItem}>Maintain relationships with entrepreneurs and other VCs</li>
        </ul>
        <p style={styles.jobDescription}>
          <strong>Requirements:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>3-5 years of experience in venture capital, investment banking, or consulting</li>
          <li style={styles.requirementItem}>MBA from top-tier business school preferred</li>
          <li style={styles.requirementItem}>Strong analytical and financial modeling skills</li>
          <li style={styles.requirementItem}>Deep interest in AI, fintech, or payment technologies</li>
          <li style={styles.requirementItem}>Excellent communication and presentation skills</li>
        </ul>
      </div>

      <div style={styles.jobCard}>
        <h3 style={styles.jobTitle}>Portfolio Operations Manager</h3>
        <div style={styles.jobMeta}>Full-Time • Abu Dhabi, UAE</div>
        <p style={styles.jobDescription}>
          Join our portfolio operations team to help our portfolio companies scale efficiently and
          achieve their growth objectives through hands-on operational support and strategic guidance.
        </p>
        <p style={styles.jobDescription}>
          <strong>Key Responsibilities:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>Support portfolio companies with operational challenges</li>
          <li style={styles.requirementItem}>Coordinate talent recruitment and executive search processes</li>
          <li style={styles.requirementItem}>Facilitate business development opportunities between portfolio companies</li>
          <li style={styles.requirementItem}>Organize portfolio events and knowledge-sharing sessions</li>
          <li style={styles.requirementItem}>Track and report on portfolio company metrics and performance</li>
        </ul>
        <p style={styles.jobDescription}>
          <strong>Requirements:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>2-4 years of experience in operations, consulting, or startup environment</li>
          <li style={styles.requirementItem}>Strong project management and organizational skills</li>
          <li style={styles.requirementItem}>Experience working with early-stage technology companies</li>
          <li style={styles.requirementItem}>Excellent interpersonal and relationship-building skills</li>
          <li style={styles.requirementItem}>Bachelor's degree from accredited university</li>
        </ul>
      </div>

      <div style={styles.jobCard}>
        <h3 style={styles.jobTitle}>Investment Analyst (AI Focus)</h3>
        <div style={styles.jobMeta}>Full-Time • Abu Dhabi, UAE</div>
        <p style={styles.jobDescription}>
          We're looking for an Investment Analyst with deep expertise in artificial intelligence and
          machine learning to help evaluate AI-focused investment opportunities and support our
          AI portfolio companies.
        </p>
        <p style={styles.jobDescription}>
          <strong>Key Responsibilities:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>Conduct technical due diligence on AI and ML companies</li>
          <li style={styles.requirementItem}>Develop investment thesis and market analysis for AI sectors</li>
          <li style={styles.requirementItem}>Support portfolio companies with AI strategy and implementation</li>
          <li style={styles.requirementItem}>Build relationships with AI researchers and industry experts</li>
          <li style={styles.requirementItem}>Create research reports on AI market trends and opportunities</li>
        </ul>
        <p style={styles.jobDescription}>
          <strong>Requirements:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>1-3 years of experience in AI/ML, either in industry or academia</li>
          <li style={styles.requirementItem}>Technical background in computer science, engineering, or related field</li>
          <li style={styles.requirementItem}>Experience with machine learning frameworks and methodologies</li>
          <li style={styles.requirementItem}>Understanding of AI commercialization and business models</li>
          <li style={styles.requirementItem}>Strong written and verbal communication skills</li>
        </ul>
      </div>

      <div style={styles.jobCard}>
        <h3 style={styles.jobTitle}>Principal, Fintech Investments</h3>
        <div style={styles.jobMeta}>Full-Time • Abu Dhabi, UAE</div>
        <p style={styles.jobDescription}>
          Senior investment professional to lead our fintech and payment innovation investment strategy
          across European and global markets. This role offers significant deal responsibility and
          portfolio company involvement.
        </p>
        <p style={styles.jobDescription}>
          <strong>Key Responsibilities:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>Lead investment decisions and transaction execution</li>
          <li style={styles.requirementItem}>Develop fintech investment strategy and thesis</li>
          <li style={styles.requirementItem}>Serve on portfolio company boards and advisory roles</li>
          <li style={styles.requirementItem}>Build network of fintech entrepreneurs and industry experts</li>
          <li style={styles.requirementItem}>Mentor junior investment team members</li>
        </ul>
        <p style={styles.jobDescription}>
          <strong>Requirements:</strong>
        </p>
        <ul style={styles.requirementsList}>
          <li style={styles.requirementItem}>7+ years of experience in venture capital or fintech industry</li>
          <li style={styles.requirementItem}>Proven track record of successful fintech investments</li>
          <li style={styles.requirementItem}>Deep understanding of payment systems and financial technology</li>
          <li style={styles.requirementItem}>Strong network in European fintech ecosystem</li>
          <li style={styles.requirementItem}>Board experience with early-stage companies preferred</li>
        </ul>
      </div>

      <h2 style={styles.subHeading}>Why Join Sapienta</h2>

      <p style={styles.text}>
        <strong>Impact:</strong> Work with cutting-edge technologies and help build the companies
        that will shape the future of AI, fintech, and payment innovation.
      </p>

      <p style={styles.text}>
        <strong>Growth:</strong> Accelerate your career in venture capital with mentorship from
        experienced investment professionals and exposure to diverse investment opportunities.
      </p>

      <p style={styles.text}>
        <strong>Network:</strong> Build relationships with top entrepreneurs, industry experts,
        and fellow investors in our focus sectors.
      </p>

      <p style={styles.text}>
        <strong>Culture:</strong> Join a collaborative, intellectually curious team that values
        long-term thinking and sustainable value creation.
      </p>

      <h2 style={styles.subHeading}>Application Process</h2>

      <p style={styles.text}>
        To apply for any of these positions, please send your resume and a brief cover letter
        explaining your interest in venture capital and Sapienta specifically to{' '}
        <a href="mailto:career@sapienta.vc" style={styles.link}>career@sapienta.vc</a>
      </p>

      <p style={styles.text}>
        Please include the position title in the subject line of your email. We review applications
        on an ongoing basis and will reach out to qualified candidates for initial conversations.
      </p>

      <p style={styles.text}>
        Sapienta VC is an equal opportunity employer committed to diversity and inclusion.
        We encourage applications from candidates of all backgrounds and experiences.
      </p>
    </div>
  );
}

export default Careers;